import React from 'react';
import Moment from 'moment';

import { RetroDateField } from '../../../../../components/inputs/RetroDateField';
import type { GlobalFieldValues } from '../types';
import { retroactiveOptionsFormatter } from '../utils';

/**
 * Prime X retroactive control. The user can type a date, jump the calendar by
 * month and year, or pick one of the retroactive period shortcuts — all three
 * resolve to the same value shape the reducer already understands.
 */
const RetroActiveInput = (props: RetroActiveInputProps) => {
  const presets = React.useMemo(
    () => props.options?.map(retroactiveOptionsFormatter) ?? [],
    [props.options]
  );

  return (
    <RetroDateField
      name="retroactive"
      value={props.value}
      presets={presets}
      minDate={toDate(props.minDate)}
      maxDate={toDate(props.maxDate)}
      defaultDate={toDate(props.defaultDate)}
      disabled={props.disabled}
      variant={props.variant === 'coverage' ? 'inline' : 'default'}
      onChange={props.setValue}
    />
  );
};

function toDate(value?: string) {
  if (!value) {
    return undefined;
  }

  const parsed = Moment(value);
  return parsed.isValid() ? parsed.toDate() : undefined;
}

export default RetroActiveInput;

type RetroActiveInputProps = {
  readonly variant?: 'coverage';
  readonly setValue: (value: string | number) => void;
  readonly options: GlobalFieldValues['options'];
  readonly value: string | number;
  readonly maxDate: string;
  readonly defaultDate: string;
  /**
   * Optional floor. The rater's retroactive rules currently supply only an
   * upper bound (`to`), so this is normally unset and the range stays open
   * below — matching the behaviour of the calendar this replaced.
   */
  readonly minDate?: string;
  readonly disabled?: boolean;
};
